import objectHash from "object-hash";
import type { DimensionField, ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { getAggregationBasedFields, getCustomFields, isDimensionBased } from "../../../../utilities/fieldsHelper.ts";
import getTrackedMeasureProperties from "../../utils/getTrackedMeasureProperties";
import { getTrackedTabularDimensionProperties } from "../../utils/getTrackedTabularDimensionProperties";

export const getFieldsHash = (fields: ReportField[]) => {
  const measures = [...getAggregationBasedFields(fields), ...getCustomFields(fields)];
  const dimensions = getDimensions(fields);

  const allMeasures = getTrackedMeasureProperties(measures).sort(sortMeasure);
  const allDimensions = getTrackedTabularDimensionProperties(dimensions);

  const hash = objectHash({ allMeasures, allDimensions });
  return hash;
};

const sortMeasure = (a: { guid: string }, b: { guid: string }) => {
  if (a.guid > b.guid) return 1;
  if (a.guid < b.guid) return -1;
  return 0;
};

const getDimensions = (fields: ReportField[]): DimensionField[] => {
  return fields.filter(isDimensionBased);
};
